const form = {
  formId: "tax-personal-05",
  formField: {
    checkbox1: {
      name: "checkbox1",
      label: "Đăng ký thuế",
    },
    checkbox2: {
      name: "checkbox2",
      label: "Thay đổi thông tin ĐKT",
    },
    organizeName: {
      name: "organ1",
      label: "1. Tên cơ quan chi trả thu nhập",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập cơ quan thuế cấp cục",
    },
    taxId: {
      name: "taxId",
      label: "2. Mã số thuế",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập cơ quan thuế quản lý",
    },
    organ1: {
      name: "organ1",
      label: "3. Cơ quan thuế quản lý cấp cục",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập cơ quan thuế quản lý cấp cục",
    },
    organ2: {
      name: "organ2",
      label: "3. Cơ quan thuế quản lý cấp chi cục",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập cơ quan thuế quản lý cấp chi cục",
    },

    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
